/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link } from '@coursera/cds-core';

import _t from 'i18n!nls/career-plans';

const styles = {
  gridContainer: css`
    margin-right: auto;
    margin-left: auto;
    margin-top: 100px;
    margin-bottom: 100px;
    padding-right: 30px;
    padding-left: 30px;

    &::before,
    &::after {
      display: table;
      content: ' ';
    }

    &::after {
      clear: both;
    }

    @media (min-width: 768px) {
      width: 750px;
    }

    @media (min-width: 992px) {
      width: 970px;
    }

    @media (min-width: 1200px) {
      width: 1170px;
    }
  `,
};

const CareerPlans404 = () => (
  <div className="rc-CareerPlans404">
    <div css={styles.gridContainer}>
      <h1 className="headline-5-text">{_t('Sorry')}</h1>

      <p className="headline-2-text">
        {_t("We couldn't find the career plan that you're looking for.")}

        <span>&nbsp;</span>
        <Link href="/browse">{_t('Browse catalog')}</Link>
      </p>
    </div>
  </div>
);

export default CareerPlans404;
